'use strict';

module.exports = Object.freeze(Object.keys(require('./personal_data_labels')));
